import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import { ShieldX, ArrowLeft } from 'lucide-react';

const RoleGuard = ({ 
  children, 
  requiredRole = null, 
  requiredPermission = null, 
  fallbackComponent = null,
  redirectTo = '/'
}) => {
  const { userRole, hasPermission } = useAuth();

  // Check role-based access
  if (requiredRole && userRole !== requiredRole) {
    if (fallbackComponent) {
      return fallbackComponent;
    }

    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center max-w-md">
          <ShieldX className="h-16 w-16 text-red-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Acceso Denegado</h2>
          <p className="text-gray-600 mb-6">
            Esta página requiere permisos de {requiredRole === 'admin' ? 'Administrador' : 
                                              requiredRole === 'shopkeeper' ? 'Shopkeeper' : 
                                              'Solo Lectura'}
          </p>
          <p className="text-sm text-gray-500 mb-6">
            Tu rol actual: {userRole === 'admin' ? 'Administrador' : 
                            userRole === 'shopkeeper' ? 'Shopkeeper' : 
                            'Solo Lectura'}
          </p>
          <Link 
            to={redirectTo}
            className="inline-flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>Volver</span>
          </Link>
        </div>
      </div>
    );
  }

  // Check permission-based access
  if (requiredPermission && !hasPermission(requiredPermission)) {
    if (fallbackComponent) {
      return fallbackComponent;
    }

    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center max-w-md">
          <ShieldX className="h-16 w-16 text-red-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Acceso Denegado</h2>
          <p className="text-gray-600 mb-6">
            No tienes permisos para acceder a esta funcionalidad
          </p>
          <p className="text-sm text-gray-500 mb-6">
            Permiso requerido: {requiredPermission}
          </p>
          <Link 
            to={redirectTo}
            className="inline-flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>Volver</span>
          </Link>
        </div>
      </div>
    );
  }

  return children;
};

export default RoleGuard;